import {
  Component,
  effect,
  ElementRef,
  HostListener,
  model,
  viewChild,
  ChangeDetectionStrategy,
} from "@angular/core";

@Component({
  selector: "claas-aside-modal-dialog",
  imports: [],
  templateUrl: "./aside-modal-dialog.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./aside-modal-dialog.scss",
})
export class AsideModalDialog {
  dialogRef =
    viewChild.required<ElementRef<HTMLDialogElement>>("asideModalDialog");

  show = model(false);

  constructor() {
    effect(() => {
      this.toggleShow(this.show());
    });
  }

  @HostListener("click", ["$event"])
  onHostClick(evt: MouseEvent) {
    if (
      evt.target === evt.currentTarget ||
      evt.target instanceof HTMLDialogElement
    ) {
      this.show.set(false);
    }
  }

  private toggleShow(show: boolean) {
    this.dialogRef().nativeElement?.[show ? "showModal" : "close"]?.();
  }
}
